import type { FC } from "react";
import type { ClientPortfolioProducerInstrumentResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { ProducerInstrumentToolRow } from "./ProducerInstrumentToolRow";

type Props = {
	producerInstruments: ClientPortfolioProducerInstrumentResponseDTO[];
	portfolioId: number;
	currencySign: string;
	expandedMap: Record<string, boolean>;
	setExpanded: (key: string, value: boolean) => void;
	noDivider: boolean;
};

export const ProducerInstrumentRowList: FC<Props> = ({
	producerInstruments,
	portfolioId,
	currencySign,
	expandedMap,
	setExpanded,
	noDivider,
}) => {
	return (
		<>
			{producerInstruments.map((instrument, instrumentIdx) => {
				const rowKey = `producer-instrument-${instrument.isin}`;
				const isLastItem = instrumentIdx === producerInstruments.length - 1;

				return (
					<ProducerInstrumentToolRow
						key={rowKey}
						producerInstrument={instrument}
						instrumentIdx={instrumentIdx}
						portfolioId={portfolioId}
						currencySign={currencySign}
						expanded={!!expandedMap[rowKey]}
						onToggle={(v: boolean) => setExpanded(rowKey, v)}
						noDivider={isLastItem && noDivider}
					/>
				);
			})}
		</>
	);
};
